import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=f0139ba8"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=f0139ba8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports